import React, { useState } from "react";
import { TextField, Paper, Box, Typography, Link, CircularProgress, Alert } from "@mui/material";
import ActionButton from "../widgets/ActionButton";
import { styled } from "@mui/system";
import { useAppDispatch, useAppSelector, useReduxPrefState } from "../../app/hooks";
import { Navigate } from "react-router-dom";
import { AuthQuery } from "../../app/features/auth/authTypes";
import { login } from "../../app/features/auth/authActions";

const StyledBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  padding: '2rem',
});

const StyledPaper = styled(Paper)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '400px',
  padding: '2rem',
});

const Login = () => {
  const [username, setUsername] = useReduxPrefState("lastLogin", "");
  const [password, setPassword] = useState("");
  const [isLoginRunning, setIsLoginRunning] = useState(false);
  const isAuthenticated = useAppSelector(state => state.auth.isAuthenticated);
  const error = useAppSelector(state => state.auth.errorMessage);
  const originalPath = useAppSelector(state => state.auth.originalPath);
  const dispatch = useAppDispatch();

  if (error && isLoginRunning)
  {
    setIsLoginRunning(false);
  }

  const handleLogin = async () => {
    setIsLoginRunning(true);
    const credentials: AuthQuery = { username, password };
    await dispatch(login(credentials));
  };

  if (isAuthenticated) {
    if(originalPath !== "/login")
      return (
        <Navigate to={originalPath} />
      );
    return (
        <Navigate to="/" />
    );
  }

  return (
    <StyledBox>
      <StyledPaper elevation={3}>
        <Typography variant="h4" component="h1" gutterBottom>
          Login
        </Typography>
        {error && <Alert severity="error">{error}</Alert>}
        <TextField label="Username" variant="outlined" margin="normal" disabled={isLoginRunning} value={username} onChange={(e) => setUsername(e.target.value)} />
        <TextField label="Password" variant="outlined" margin="normal" type="password" disabled={isLoginRunning} value={password} onChange={(e) => setPassword(e.target.value)} />
        <ActionButton type="submit" disabled={isLoginRunning} onClick={handleLogin}>
          {isLoginRunning ? <CircularProgress size={24} /> : "Login"}
        </ActionButton>
        <Link href="/reset-password" variant="body2">
          Forgot password?
        </Link>
      </StyledPaper>
    </StyledBox>
  );
};

export default Login;